import React, { createContext, useContext, useState, useEffect } from 'react';
import { getPurchaseOrdersServiceBySupplier } from '../../client/purchaseOrder';
import { getPermissions } from '../../client/permissions';
import { jwtDecode } from 'jwt-decode';
import { getUser } from '../../client/users';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);  
  const [supplierId, setSupplierId] = useState(null);
  const [supplierName, setSupplierName] = useState(null); 
  const [categorySupplier, setCategorySupplier] = useState(null);
  const [supplierCode, setSupplierCode] = useState(null);
  const [supplierCriticity, setSupplierCriticity] = useState(null);
  const [roleId, setRoleId] = useState(null);
  const [permissions, setPermissions] = useState([]); 


const normalizeAssignedPermissions = (rawPermissions = []) => {
  if (rawPermissions.length > 0 && rawPermissions.every(p => 'id' in p && 'text' in p && Object.keys(p).length <= 2)) {
    return rawPermissions;
  }
  return rawPermissions
    .filter(p => p?.assigned === true)           
    .map(p => ({ id: p.id, text: p.text }));     
};


 const refreshPermissions = async (userIdParam = null) => {
   const userIdToUse = userIdParam || user?.id;
   if (!userIdToUse) {
     console.warn('No se puede actualizar permisos: usuario no encontrado');
     return false;
   }
   try {
     const { data: apiUser } = await getUser(userIdToUse);

     const newPerms = normalizeAssignedPermissions(apiUser?.permissions || []);

     const currentIds = normalizeAssignedPermissions(permissions).map(p => p.id).sort((a,b)=>a-b);
     const newIds = newPerms.map(p => p.id).sort((a,b)=>a-b);
     const changed = JSON.stringify(currentIds) !== JSON.stringify(newIds);

if (changed) {
      setPermissions(newPerms);
      localStorage.setItem('permissions', JSON.stringify(newPerms));


      return true;
    }
     return false;
   } catch (error) {
     console.error('Error al actualizar permisos:', error);
     return false;
   }
 };



  useEffect(() => {
    const storedUserData = localStorage.getItem('userData');
    const storedToken = localStorage.getItem('token');
    const storedSupplierId = localStorage.getItem('supplierId');
    const storedSupplierName = localStorage.getItem('supplierName'); 
    const storedCategory = localStorage.getItem('categorySupplier');
    const storedSupplierCode = localStorage.getItem('supplierCode');
    const storedSupplierCriticity = localStorage.getItem('supplierCriticity');
    const storedRoleId = localStorage.getItem('roleId');
    const storedPermissions = localStorage.getItem('permissions'); 


    if (storedUserData && storedToken) {
      const parsedUserData = JSON.parse(storedUserData);

      setUser(parsedUserData);
      setToken(storedToken);
      setSupplierId(storedSupplierId);
      setCategorySupplier(storedCategory);
      setSupplierCode(storedSupplierCode);
      setSupplierCriticity(storedSupplierCriticity);
      setRoleId(storedRoleId);
      setSupplierName(storedSupplierName);

      if (storedPermissions) {
        setPermissions(normalizeAssignedPermissions(JSON.parse(storedPermissions)));
      } else if (parsedUserData.permissions) {
        const normalized = normalizeAssignedPermissions(parsedUserData.permissions);
        setPermissions(normalized);
        localStorage.setItem('permissions', JSON.stringify(normalized));
      }

     // updatePurchaseOrders(storedSupplierCode);
    }
    setLoading(false);
  }, []);

  const login =  async (userData, token, supplierId, supplierName, category, supplierCode, supplierCriticity, roleId) => {
    localStorage.setItem('token', token);
    localStorage.setItem('userData', JSON.stringify(userData));
    localStorage.setItem('userId', userData.id); 
    localStorage.setItem('supplierId', supplierId);
    localStorage.setItem('supplierName', supplierName); 
    localStorage.setItem('categorySupplier', category);
    localStorage.setItem('supplierCriticity', supplierCriticity);
    localStorage.setItem('supplierCode', supplierCode);
    localStorage.setItem('roleId', roleId);

    if (userData.permissions) {
      const normalized = normalizeAssignedPermissions(userData.permissions);
      localStorage.setItem('permissions', JSON.stringify(normalized));
      setPermissions(normalized);
      userData = { ...userData, permissions: normalized };
    }

    sessionStorage.removeItem('hasShownContractModal');
    sessionStorage.removeItem('hasShownHomologationModal');

    setUser(userData);
    setToken(token);
    setSupplierId(supplierId);
    setCategorySupplier(category);
    setSupplierCode(supplierCode);
    setSupplierCriticity(supplierCriticity);
    setRoleId(roleId);
    setSupplierName(supplierName); 

  //  await updatePurchaseOrders(supplierCode);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
    localStorage.removeItem('supplierId');
    localStorage.removeItem('categorySupplier');
    localStorage.removeItem('hasEvaluation');
    localStorage.removeItem('roleId');
    localStorage.removeItem('permissions'); 
    localStorage.removeItem('supplierName');

    setUser(null);
    setToken(null);
    setSupplierId(null);
    setCategorySupplier(null);
    setRoleId(null);
    setPermissions([]); 
    setSupplierName(null);

  };

  const checkTokenExpiration = () => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      try {
        const decoded = jwtDecode(storedToken);
        const currentTime = Date.now() / 1000;
        
        if (decoded.exp < currentTime) {
          logout(); 
        }
      } catch (error) {
        console.error('Error al decodificar el token:', error);
        logout(); 
      }
    }
  };

  useEffect(() => {
    checkTokenExpiration();

    const interval = setInterval(checkTokenExpiration, 60000);
    return () => clearInterval(interval);
  }, []);

  /*
    if (loading) {
    return <div>Loading...</div>;  
  }
*/

  return (
    <AuthContext.Provider value={{
      user,
      token,
      loading,
      supplierId,
      supplierName,
      roleId,
      categorySupplier,
      supplierCode,
      supplierCriticity,
      permissions, 
      login,
      logout,
      refreshPermissions
      }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);